<template>
  <div style="margin: 5px 0">
    <span class="tag" :class="getCommitmentStatusClass(commitment)">{{ commitment.status }}</span>
    {{ commitment.description }}
    <i class="fa fa-check" @click="updateCommitment(commitment, 'APPROVED')" title="Approve"></i>
    <i class="fa fa-times" @click="updateCommitment(commitment, 'DENIED')" title="Deny"></i>
    <i class="fa fa-undo" @click="updateCommitment(commitment, 'PENDING')" title="Pending"></i>
    <a :href="adminLink" target="_blank" title="Edit" style="padding-left: 4px;">
      <i class="fa fa-edit" />
    </a>
  </div>
</template>
<script>
import Commitment from '@/services/commitments/'
export default {
  name: 'StaffCommitmentSummary',
  props: {
    commitment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    adminLink() {
      return (
        (process.env.VUE_APP_ADMIN_ROOT || '/admin') +
        '/evaluations/commitment/' +
        this.commitment.id +
        '/change/'
      )
    },
  },
  methods: {
    getCommitmentStatusClass(commitment) {
      if (commitment.status) {
        if (commitment.status === 'APPROVED') {
          return { 'is-success': true }
        } else if (commitment.status === 'DENIED') {
          return { 'is-danger': true }
        }
      }
    },
    updateCommitment(commitment, status) {
      const fields = ['status']
      commitment.status = status
      Commitment.api.update(commitment, fields).then(() => {})
    },
  },
}
</script>
